import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchLandPrice, fetchTrendPrice, resetUnitLandPrice, resetUnitTrendPrice, UnitLandPriceParam } from '@Root/slices/myhouse/unitPrice'
import { RootState } from '@Root/slices'

export default function useUnitPrice() {
  const dispatch = useDispatch()
  const unitPrice = useSelector((state: RootState) => state.unitPrice)

  const loadUnitTrendPrice = useCallback(
    (houseNo: number) => {
      dispatch(fetchTrendPrice(houseNo))
    },
    [dispatch],
  )

  const loadUnitLandPrice = useCallback(
    (param: UnitLandPriceParam) => {
      dispatch(fetchLandPrice(param))
    },
    [dispatch],
  )

  const setUnitTrendPrice = useCallback(() => {
    dispatch(resetUnitTrendPrice())
  }, [dispatch])

  const setUnitLandPrice = useCallback(() => {
    dispatch(resetUnitLandPrice())
  }, [dispatch])

  return {
    loadUnitTrendPrice,
    setUnitTrendPrice,
    loadUnitLandPrice,
    setUnitLandPrice,
    unitPrice,
  }
}
